// removed by extract-text-webpack-plugin
module.exports = {"layout":"_3cWjGifQwKdSK1pcIdK2dt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/app.css
// module id = 510
// module chunks = 0